import openExportShare, {
  BASE_EXCLUDED_SOCIALS,
  ShareTouchpoints,
} from '@/utils/editor/openExportShare';

/**
 * A preset share hands out a *link*, not a file, so every destination that acts
 * on the shared media are hidden on top of the always-excluded base list. The
 * project-scoped link flows (`present`, `presentation_link`) need no entry —
 * `POPUP` mode drops them already. `share_link` ("Share With") is kept: it
 * appears on its own if a share ever carries a `fileUid`.
 */
const EXCLUDED_SOCIALS: readonly string[] = [
  ...BASE_EXCLUDED_SOCIALS,
  ShareTouchpoints.PostToPicsart,
  ShareTouchpoints.Earn,
  ShareTouchpoints.OneHourPhoto,
  ShareTouchpoints.Challenges,
];

/**
 * Instagram and TikTok have to be opted in or they don't render. YouTube is
 * left out deliberately — it only renders for a video url, which a short link
 * never is.
 */
const INCLUDED_SOCIALS: readonly string[] = [
  ShareTouchpoints.Instagram,
  ShareTouchpoints.Tiktok,
];

/**
 * The Picsart sheet, as the fallback for surfaces with no OS share sheet. The
 * short link stands in for the media url, with no `fileUid` since no Drive file
 * backs a preset.
 */
const openShareSheet = (url: string): Promise<void> =>
  openExportShare({
    externals: [{ url }],
    includedSocials: INCLUDED_SOCIALS,
    excludedSocials: EXCLUDED_SOCIALS,
    // Nothing to save to the device: hide the button, and suppress the native
    // auto-download that would otherwise fire on open and write a stray file.
    hideDownloadButton: true,
    skipAutoDownload: true,
    // The sheet's own Copy link copies a Drive public-invitation URL and renders
    // disabled without a `fileUid`.
    hideCopyLink: true,
  });

export default openShareSheet;
